'use client';

import Cookie from 'js-cookie';
import { signOut, useSession } from 'next-auth/react';
import { useRouter } from 'next-nprogress-bar';
import { useEffect } from 'react';

import { AlertaController } from '@components';
import { TipoSessaoEnum } from '@enums/tipo-sessao.enum';
import { clientIdGovBR, urlRedirectGovBR } from '@utils';

type Props = {
  children?: React.ReactNode;
};

export const LogoutProvider = ({ children }: Props) => {
  const { data: sessao } = useSession();

  const rota = useRouter();

  const validarSessaoGestor = async () => {
      if (Cookie.get('sessao-gestor-encerrada')) {
        AlertaController.disparar({
          titulo: 'Usuário sem permissão',
          tipo: 'erro',
          mensagemComHtml: `
            <p>Como gestor, você não possui acesso a está página.</p>
            <br />
            <p>Acesse novamente o link do e-mail e faça login para concluir a assinatura.
          `,
          textoConfirmar: 'Ok',
          fechar: false,
        }).then(async ({ isConfirmed }) => {
          if (isConfirmed) {
            await signOut({
              redirect: false,
            })
              .then(() => {
                rota.push(
                  `${
                    process.env.NEXT_PUBLIC_LOGIN_UNICO_API
                  }/sso/sair?client_id=${clientIdGovBR}&redirect_uri=${encodeURI(
                    urlRedirectGovBR,
                  )}`,
                );

                Cookie.remove('sessao-gestor-encerrada');
              })
          }
        });
      }
    };

  useEffect(() => {
    validarSessaoGestor();

    if (sessao?.user.error) {
      if (sessao?.user.error === 'sessao-expirada')
        sessionStorage.setItem('sessao', 'sessao-expirada');

      if (sessao?.user.error === 'autenticacao-erro')
        Cookie.set('autenticacao-erro', 'autenticacao-erro');

      if (
        sessao?.user.tipo &&
        [TipoSessaoEnum.ENVIO_DE_MATERIA, TipoSessaoEnum.ASSINATURA].includes(sessao?.user.tipo)
      ) {
        signOut({
          redirect: false,
        }).then(() => {
          rota.push(
            `${
              process.env.NEXT_PUBLIC_LOGIN_UNICO_API
            }/sso/sair?client_id=${clientIdGovBR}&redirect_uri=${encodeURI(urlRedirectGovBR)}`,
          );
        });
      } else {
        signOut({ callbackUrl: '/' });
      }
    }
  }, [sessao]);

  return <>{children}</>;
};
